import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const SocialsPage = lazy(() => import('../pages/socials/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const AreasPage = lazy(() => import('../pages/areas/page'));
const RickmansworthPage = lazy(() => import('../pages/areas/rickmansworth/page'));
const NorthwoodPage = lazy(() => import('../pages/areas/northwood/page'));
const PinnerPage = lazy(() => import('../pages/areas/pinner/page'));
const ChorleywoodPage = lazy(() => import('../pages/areas/chorleywood/page'));
const RadlettPage = lazy(() => import('../pages/areas/radlett/page'));
const BusheyPage = lazy(() => import('../pages/areas/bushey/page'));
const GerrardsCrossPage = lazy(() => import('../pages/areas/gerrards-cross/page'));
const WatfordPage = lazy(() => import('../pages/areas/watford/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const Error500Page = lazy(() => import('../pages/Error500'));
const Error403Page = lazy(() => import('../pages/Error403'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/socials',
    element: <SocialsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/areas',
    element: <AreasPage />,
  },
  {
    path: '/areas/bushey',
    element: <BusheyPage />,
  },
  {
    path: '/areas/pinner',
    element: <PinnerPage />,
  },
  {
    path: '/areas/radlett',
    element: <RadlettPage />,
  },
  {
    path: '/areas/rickmansworth',
    element: <RickmansworthPage />,
  },
  {
    path: '/areas/northwood',
    element: <NorthwoodPage />,
  },
  {
    path: '/areas/chorleywood',
    element: <ChorleywoodPage />,
  },
  {
    path: '/areas/gerrards-cross',
    element: <GerrardsCrossPage />,
  },
  {
    path: '/areas/watford',
    element: <WatfordPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/error-500',
    element: <Error500Page />,
  },
  {
    path: '/error-403',
    element: <Error403Page />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
